var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "dragRef",
      staticClass: "draggable-element",
      style: {
        left: `${_vm.currentX}px`,
        top: `${_vm.currentY}px`,
        width: `${_vm.w}px`,
        height: `${_vm.h}px`,
      },
      attrs: { id: "dragElement" },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }